import { AppForm } from '../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { ApplicationAppEntityApplicationRead, ApplicationAppEntityApplicationWrite } from '../../../../../../openapi';

export class CorrespondenceForm extends AppForm {
  constructor() {
    super({
      country: new FormControl(null, Validators.maxLength(255)),
      voivodeship: new FormControl(null, Validators.maxLength(255)),
      county: new FormControl(null, Validators.maxLength(255)),
      municipality: new FormControl(null, Validators.maxLength(255)),
      city: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      street: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      houseNumber: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      apartmentNumber: new FormControl(null, [Validators.maxLength(255)]),
      postOffice: new FormControl(null, [Validators.maxLength(255)]),
      postalCode: new FormControl(null, [Validators.required, Validators.maxLength(255)])
    });
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      correspondenceCountry: this.value.country,
      correspondenceVoivodeship: this.value.voivodeship,
      correspondenceCounty: this.value.county,
      correspondenceMunicipality: this.value.municipality,
      correspondenceCity: this.value.city,
      correspondenceStreet: this.value.street,
      correspondenceHouseNumber: this.value.houseNumber,
      correspondenceApartmentNumber: this.value.apartmentNumber,
      correspondencePostOffice: this.value.postOffice,
      correspondencePostalCode: this.value.postalCode
    };
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues({
      country: value?.correspondenceCountry,
      voivodeship: value?.correspondenceVoivodeship,
      county: value?.correspondenceCounty,
      municipality: value?.correspondenceMunicipality,
      city: value?.correspondenceCity,
      street: value?.correspondenceStreet,
      houseNumber: value?.correspondenceHouseNumber,
      apartmentNumber: value?.correspondenceApartmentNumber,
      postOffice: value?.correspondencePostOffice,
      postalCode: value?.correspondencePostalCode
    });
  }
}
